// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown-menu-box {
  border: 1px solid grey;
  min-width: -moz-max-content;
  min-width: max-content;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);
  position: absolute;
  background: white;
  right: 0;
  z-index: 10;
}

.caret.caret-right-align {
  position: absolute;
  top: 50%;
  right: 12px;
  margin-top: -2px;
  vertical-align: middle;
}

.menu-item-focus {
  color: #262626;
  text-decoration: none;
  background-color: #f5f5f5;
}`, "",{"version":3,"sources":["webpack://./../../libraries/components/dist/src/Dropdown/Dropdown.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,2BAAA;EAAA,sBAAA;EACA,4EAAA;EACA,kBAAA;EACA,iBAAA;EACA,QAAA;EACA,WAAA;AACJ;;AAEA;EACI,kBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;AACJ;;AAEA;EACI,cAAA;EACA,qBAAA;EACA,yBAAA;AACJ","sourcesContent":[".dropdown-menu-box {\n    border: 1px solid grey;\n    min-width: max-content;\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);\n    position: absolute;\n    background: white;\n    right: 0;\n    z-index: 10;\n}\n\n.caret.caret-right-align {\n    position: absolute;\n    top: 50%;\n    right: 12px;\n    margin-top: -2px;\n    vertical-align: middle;\n}\n\n.menu-item-focus {\n    color: #262626;\n    text-decoration: none;\n    background-color: #f5f5f5;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
